<template>
  <div style="padding: 0.5em">
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <h4 class="mr-2">Gerenciar Campos de Formulários</h4>
      <div>
        <SGPFormBotaoComponent
          class="text-capitalize mr-2"
          outlined
          :to="{name: 'ctrl-formularios-dinamicos'}"
        >
          <SGPIconComponent>mdi-form-select</SGPIconComponent>
          Gerenciar formulários
        </SGPFormBotaoComponent>

        <SGPFormBotaoComponent
          @click="abrirModal = true"
          class="text-capitalize"
        >
          <SGPIconComponent>mdi-plus</SGPIconComponent>
          Novo Campo
        </SGPFormBotaoComponent>
      </div>
    </div>

    <SGPPaginacaoComponent
      :paginacao="paginacao"
      v-if="listaDeCampos.length"
      botaoFiltrarDeletados
      :filtrarDeletados="mostrarDeletados"
      @sgpAtualizarPaginacao="realizarPaginacao"
      @sgpPaginacaoComponentFiltrarDeletados="gerenciaMostrarDeletados"
      class="mt-5"
      :key="paginacao"
    >
      <SGPTabelaComponent
        :colunas="colunas"
        :dados="listaDeCampos"
        :usuarioPodeExcluir="false"
        filtrarDeletados
        :mostrarSomenteDeletados="mostrarDeletados"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
        @sgpTabelaModalCadastrarEmit="abrirPrevisualizar"
        filtroText
      >
        <template v-slot:item.acoes="{ item }">
          <div :class="`text-right ${ item.deleted_at ? 'item-deletado' : ''}`">            
            <SGPFormBotaoComponent 
              fab
              small
              text
              v-if="!item.deleted_at && !item.ctrl_formularios_dinamicos.length"
              color="grey"
              class="mr-1 sgp-opacity-3"
            >
              <SGPIconComponent>mdi-checkbox-multiple-blank</SGPIconComponent>
            </SGPFormBotaoComponent>

            <SGPFormBotaoComponent
              fab
              small
              text
              v-if="!item.deleted_at && item.ctrl_formularios_dinamicos.length"
              @click="gerenciarModalListaFormularios(item)"
              color="red"
              class="mr-1"
            >
              <SGPIconComponent>mdi-checkbox-multiple-blank</SGPIconComponent>
            </SGPFormBotaoComponent>
          
            <SGPFormBotaoComponent
              fab
              small
              text
              v-if="!item.deleted_at"
              @click="editContato(item)"
              color="red"
              class="mr-1"
            >
              <SGPIconComponent>mdi-pencil</SGPIconComponent>
            </SGPFormBotaoComponent>
          
            <SGPFormBotaoComponent
              fab
              small
              text
              color="black"
              v-if="item.deleted_at" @click="restaurarCampoFormulario(item)"
            >
              <SGPIconComponent>mdi-backup-restore</SGPIconComponent>
            </SGPFormBotaoComponent>

            <SGPFormBotaoComponent
              fab
              small
              text
              v-else
              @click="deletarCampoFormulario(item)"
              color="primary"
            >
              <SGPIconComponent>mdi-trash-can-outline</SGPIconComponent>
            </SGPFormBotaoComponent>
          </div>
        </template>
      </SGPTabelaComponent>
    </SGPPaginacaoComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>


    <SGPModalComponent
      v-if="abrirModalListaFormularios"
      tamanho="md"
      titulo="Lista de formulários"
      @sgpModalFechar="fecharModalListaFormularios"
      :mostrarFooter="true"
    >
      <div class="d-flex" style=" box-lines: multiple; flex-wrap: wrap;">
        <div
          class="mr-1 mb-2"
          style="max-width: 100% !important;"
          v-for="formulario in listaFormularios"
          :key="`formulario-${formulario.id}`"
        >
          <SGPFormBotaoComponent 
            :to="{name: 'ctrl-formularios-dinamicos-edit', params: { id: formulario.id}}"
            class="text-capitalize"
            small
            rounded
            color="blue-grey lighten-4"
          >
            {{ formulario.titulo }} 
          </SGPFormBotaoComponent>        
        </div>
      </div>

      <div class="text-right">
        <SGPFormBotaoComponent
          outlined
          color="black"
          class="text-capitalize"
          @click="fecharModalListaFormularios()"
        >
          Cancelar
        </SGPFormBotaoComponent>
      </div>
    </SGPModalComponent>

    <SGPModalComponent
      v-if="abrirModalBloqueioDelecao"
      tamanho="sm"
      titulo="Excluir campo"
      @sgpModalFechar="fecharModalBloqueioDelecao"
      :mostrarFooter="true"
    >
      <div class="text-center">
        <span class="text-red font-size-20">Atenção!</span>
        <p>O campo selecionado está sendo usado por um ou mais formulários.</p>

        <div
          class="mb-1"
          v-for="formulario in listaFormularios"
          :key="`formulario-${formulario.id}`"
        >
          <strong class="text-red">{{ formulario.titulo }}</strong>
        </div>
      </div>

      <div class="text-right">
        <SGPFormBotaoComponent
          outlined
          color="black"
          class="text-capitalize"
          @click="fecharModalBloqueioDelecao()"
        >
          Cancelar
        </SGPFormBotaoComponent>
      </div>
    </SGPModalComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="xl"
      titulo="Campo"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioCampoComponent
        :tipoFormulario="tipoFormulario"
        :campo="campo"
        @fecharModal="fecharModal"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent 
      v-if="abrirModalConfirmacaoDelecao"
      @sgpCancelarDelecaoEmit="abrirModalConfirmacaoDelecao = false"
      @sgpConfirmarDelecaoEmit="deletarCampoDefinitivamente"
    />

    <SGPLoadingComponent v-if="loadingCampos" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FormularioCampoComponent from "../components/FormularioCampoComponent.vue";
export default {
  name: "CtrlCamposPage",
  components: { FormularioCampoComponent },
  data() {
    return {
      tipoFormulario: "salvar",
      abrirModal: false,
      campo: false,
      abrirModalBloqueioDelecao: false,
      listaFormularios: [],
      abrirModalConfirmacaoDelecao: false,
      campoSelecionado: null,
      mostrarDeletados: false,
      abrirModalListaFormularios: false
    };
  },
  async created () {
    await this.listarCampos({ trashed: 1 });
    // this.listarIndicesFichasTecnicas();
  },
  computed: {
    ...mapGetters("ctrlCampos", [
      "listaDeCtrlCampos",
      "loadingCampos"
    ]),

    listaDeCampos () {
      let campos = []
      if (this.listaDeCtrlCampos) {
        campos = this.listaDeCtrlCampos.data
      }

      return campos
    },

    colunas() {
      return [
        {
          key: "label",
          label: "Label",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "tipo_campo",
          label: "Tipo do campo",
          sortable: true,
        },
        {
          key: "ctrl_indice_ficha_tecnica.label",
          label: "Indice Ficha Técnica",
          sortable: true
        },
        {
          key: "acoes",
          label: "",
          sortable: false
        },
      ];
    },

    paginacao() {
      if (this.listaDeCtrlCampos) {
        const paginate = {
          per_page: this.listaDeCtrlCampos.per_page,
          total: this.listaDeCtrlCampos.total,
          current_page: this.listaDeCtrlCampos.current_page,
        };
        return paginate;
      }
      return {
        per_page: 100,
        total: 100,
        current_page: 1,
      };
    }
  },
  methods: {
    ...mapActions("ctrlCampos", [
      "listarCampos",
      "deletarCampo",
      "restaurarCampo"
    ]),

    // ...mapActions("ctrlIndicesFichasTecnicas", [
    //   "listarIndicesFichasTecnicas"
    // ]),

    editContato(campo) {
      this.tipoFormulario = "editar";
      this.abrirModal = true;
      this.campo = {
        ...campo,
        opcoes: [...campo.ctrl_campos_opcoes],
      };
    },

    fecharModal() {
      this.abrirModal = false;
      this.campo = false;
      this.tipoFormulario = "salvar";
    },

    fecharModalBloqueioDelecao() {
      this.abrirModalBloqueioDelecao = false;
    },
    
    deletarCampoFormulario(item) {
      this.listaFormularios = []
      if (item.ctrl_formularios_dinamicos.length) {
        this.abrirModalBloqueioDelecao = true;
        this.listaFormularios = item.ctrl_formularios_dinamicos;
        return;
      }

      this.abrirModalConfirmacaoDelecao = true
      this.campoSelecionado = item      
    },

    async deletarCampoDefinitivamente() {
      await this.deletarCampo(this.campoSelecionado);
      this.abrirModalConfirmacaoDelecao = false
    },

    async restaurarCampoFormulario(item) {
      await this.restaurarCampo(item)
    },

    async gerenciaMostrarDeletados(val) {
      this.mostrarDeletados = val
      
      let payload = {
        per_page: this.paginacao.per_page,
        current_page: 1,
        trashed: 1
      }

      if (val) {
        payload.trashed = 0
      }

      await this.listarCampos(payload)
    },

    gerenciarModalListaFormularios (item) {
      this.abrirModalListaFormularios = true
      this.listaFormularios = []
      
       if (item.ctrl_formularios_dinamicos.length) {
        this.listaFormularios = item.ctrl_formularios_dinamicos;
        return;
      }
    },

    fecharModalListaFormularios () {
      this.abrirModalListaFormularios = false
    },

    async realizarPaginacao (paginacao) {
      let payload = {
        ...paginacao,
        trashed: this.mostrarDeletados ? 0 : 1
      }

      await this.listarCampos(payload);
    },
  },
};
</script>

<style scoped>
.v-main__wrap {
  background: #fcfcfc !important;
}
</style>
